(function () {
  if (window.WestmoreBundleFunnel) return;
  window.WestmoreBundleFunnel = true;

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function activateBundleXQuantity(qty) {
    document.querySelectorAll('.js-bx-offer').forEach((offer) => {
      const title = ((offer.querySelector('.bx-offer-title') || offer).textContent || '').replace(/\s+/g, ' ');
      const match = new RegExp('Buy\\s*' + qty + '\\b', 'i').test(title);
      if (match && !offer.classList.contains('bx-active')) offer.click();
    });
    document.querySelectorAll('product-form [name="quantity"], .product-form [name="quantity"]').forEach((input) => {
      input.value = String(qty);
    });
  }

  function waitForBundleXQuantity(qty) {
    activateBundleXQuantity(qty);
    return new Promise((resolve) => {
      const started = Date.now();
      const tick = () => {
        const input = document.querySelector('product-form [name="quantity"]');
        if ((input && String(input.value) === String(qty)) || Date.now() - started > 500) {
          if (input) input.value = String(qty);
          resolve();
          return;
        }
        requestAnimationFrame(tick);
      };
      tick();
    });
  }

  function fetchConfigJSON() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
  }

  function mergeLineItems(items) {
    const merged = [];
    items.forEach((item) => {
      const existing = merged.find(
        (row) => row.id === item.id && String(row.selling_plan || '') === String(item.selling_plan || '')
      );
      if (existing) existing.quantity += item.quantity;
      else merged.push({ ...item });
    });
    return merged;
  }

  function presentCart(response) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      window.location = window.routes.cart_url;
      return;
    }
    drawer.classList.toggle('is-empty', Number(response.item_count) === 0);
    const paint = (state) => {
      if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
        drawer.renderContents(state);
        drawer.classList.toggle('is-empty', Number(state.item_count) === 0);
        return;
      }
      return refreshCart(state && state.sections);
    };
    if (response.sections && response.sections['cart-drawer']) return paint(response);
    const sectionIds = drawer.getSectionsToRender().map((section) => section.id).join(',');
    return fetch(`${window.routes.cart_url}?sections=${sectionIds}`)
      .then((res) => res.json())
      .then((sections) => paint({ ...response, sections: sections }))
      .catch(() => refreshCart());
  }

  function refreshCart(sections) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && sections) {
      drawer.renderContents({ sections: sections, id: null });
      return;
    }
    return fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const incoming = html.querySelector('#CartDrawer');
        const current = document.getElementById('CartDrawer');
        if (incoming && current) current.innerHTML = incoming.innerHTML;
        const overlay = document.querySelector('#CartDrawer-Overlay');
        if (drawer && overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        if (drawer) {
          drawer.classList.remove('is-empty');
          drawer.open();
        }
      });
  }

  class WestmoreBundleOffer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.packsRoot = this.querySelector('[data-wbo-packs]');
      this.addButton = this.querySelector('[data-wbo-add]');
      this.skipButton = this.querySelector('[data-wbo-skip]');
      this.errorEl = this.querySelector('[data-wbo-error]');
      this.data = this.readData();
      this.selectedQty = 2;
      this.renderPacks();
      this.querySelectorAll('[data-wbo-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });
      this.addButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.addBundle();
      });
      this.skipButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.continueSingle();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });
    }

    readData() {
      const node = document.getElementById('WestmoreBundleOfferData');
      if (!node) return { variants: [], currency: 'USD', pack2Percent: 10, pack3Percent: 20 };
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return { variants: [], currency: 'USD', pack2Percent: 10, pack3Percent: 20 };
      }
    }

    currentUnitPrice() {
      const sellingPlan = this.getSellingPlan();
      const first = this.data.variants.find((variant) => variant.available) || this.data.variants[0];
      if (!first) return this.data.unitPrice || 0;
      return sellingPlan ? first.subscriptionPrice || first.price : first.price;
    }

    getSellingPlan() {
      if (!this.productForm) return '';
      const input = this.productForm.form.querySelector('[name="selling_plan"]');
      return input && input.value ? input.value : '';
    }

    getSelectedVariantId() {
      if (!this.productForm) return this.data.variants[0] && this.data.variants[0].id;
      const input = this.productForm.form.querySelector('[name="id"]');
      return input && input.value ? Number(input.value) : this.data.variants[0] && this.data.variants[0].id;
    }

    variantOptions(selectedId) {
      return this.data.variants
        .map((variant) => {
          const selected = Number(variant.id) === Number(selectedId) ? ' selected' : '';
          const disabled = variant.available ? '' : ' disabled';
          return `<option value="${variant.id}"${selected}${disabled}>${variant.title}</option>`;
        })
        .join('');
    }

    renderPacks() {
      const unit = this.currentUnitPrice();
      const currency = this.data.currency;
      const packs = [
        { qty: 2, percent: this.data.pack2Percent, label: 'Buy 2' },
        { qty: 3, percent: this.data.pack3Percent, label: 'Buy 3' },
      ];
      const selectedId = this.getSelectedVariantId();
      this.packsRoot.innerHTML = packs
        .map((pack) => {
          const was = unit * pack.qty;
          const now = Math.round(was * (100 - pack.percent) / 100);
          const selects = Array.from({ length: pack.qty }, (_, index) => {
            return `<div class="wbo-shade">
              <label>Shade ${index + 1}</label>
              <select data-wbo-shade="${pack.qty}-${index}">${this.variantOptions(selectedId)}</select>
            </div>`;
          }).join('');
          return `<div class="wbo-pack${pack.qty === this.selectedQty ? ' is-selected' : ''}" data-wbo-qty="${pack.qty}" role="button" tabindex="0">
            <div class="wbo-pack__top">
              <div>
                <span class="wbo-pack__name">${pack.label}</span>
                <span class="wbo-pack__save">Save ${pack.percent}%</span>
              </div>
              <div class="wbo-pack__prices">
                <span class="wbo-pack__now">${formatMoney(now, currency)}</span>
                <span class="wbo-pack__was">${formatMoney(was, currency)}</span>
              </div>
            </div>
            <div class="wbo-pack__variants">${selects}</div>
          </div>`;
        })
        .join('');

      this.packsRoot.querySelectorAll('[data-wbo-qty]').forEach((button) => {
        button.addEventListener('click', (event) => {
          if (event.target.closest('select, label')) return;
          this.selectedQty = Number(button.dataset.wboQty);
          this.packsRoot.querySelectorAll('.wbo-pack').forEach((pack) => {
            pack.classList.toggle('is-selected', Number(pack.dataset.wboQty) === this.selectedQty);
          });
        });
      });
    }

    open(productForm) {
      this.productForm = productForm;
      this.selectedQty = 2;
      this.renderPacks();
      activateBundleXQuantity(1);
      document.body.appendChild(this);
      this.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    }

    showError(message) {
      this.errorEl.textContent = message;
      this.errorEl.style.display = message ? 'block' : 'none';
    }

    continueSingle() {
      const id = this.getSelectedVariantId();
      if (!id) {
        this.showError('Please choose a shade.');
        return;
      }
      activateBundleXQuantity(1);
      const sellingPlan = this.getSellingPlan();
      const item = { id: Number(id), quantity: 1 };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      this.addItems([item], { forceSingle: true });
    }

    addBundle() {
      activateBundleXQuantity(1);
      const sellingPlan = this.getSellingPlan();
      const items = [];
      for (let index = 0; index < this.selectedQty; index += 1) {
        const select = this.querySelector(`[data-wbo-shade="${this.selectedQty}-${index}"]`);
        const id = select && select.value ? Number(select.value) : this.getSelectedVariantId();
        if (!id) {
          this.showError('Please choose a shade for each piece.');
          return;
        }
        const item = { id: id, quantity: 1 };
        if (sellingPlan) item.selling_plan = Number(sellingPlan);
        items.push(item);
      }
      this.addItems(items);
    }

    addItems(items, options) {
      this.showError('');
      this.addButton.disabled = true;
      this.skipButton.disabled = true;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sectionPayload = {};
      if (cart && typeof cart.getSectionsToRender === 'function') {
        sectionPayload.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
        sectionPayload.sections_url = window.location.pathname;
      }
      const desired = mergeLineItems(items);

      const postJSON = (url, body) => {
        const config = fetchConfigJSON();
        config.body = JSON.stringify(Object.assign({}, body, sectionPayload));
        return fetch(url, config).then((response) => response.json());
      };

      const lineForVariant = (state, variantId) => {
        return (state.items || []).find((item) => Number(item.variant_id) === Number(variantId));
      };

      waitForBundleXQuantity(1)
        .then(() => {
          return desired.reduce((chain, item) => {
            return chain.then((state) => {
              const existing = state && lineForVariant(state, item.id);
              const addBody = { items: [{ id: item.id, quantity: 1 }] };
              if (item.selling_plan) addBody.items[0].selling_plan = item.selling_plan;
              return postJSON(`${window.routes.cart_add_url}`, addBody).then((response) => {
                if (response.status) throw new Error(response.description || response.message || 'Could not add this to cart.');
                const targetQty = options && options.forceSingle ? 1 : item.quantity + (existing ? existing.quantity : 0);
                const line = lineForVariant(response, item.id);
                if (!line || line.quantity === targetQty) return response;
                return postJSON(`${window.routes.cart_change_url}`, { id: line.key, quantity: targetQty });
              });
            });
          }, Promise.resolve(null));
        })
        .then((response) => {
          if (!response) return;
          this.close();
          return presentCart(response);
        })
        .catch((error) => {
          this.showError((error && error.message) || 'Could not add this to cart. Please try again.');
        })
        .finally(() => {
          this.addButton.disabled = false;
          this.skipButton.disabled = false;
        });
    }
  }

  if (!customElements.get('westmore-bundle-offer')) {
    customElements.define('westmore-bundle-offer', WestmoreBundleOffer);
  }

  function openWestmoreOffer(productForm) {
    if (!productForm || productForm.dataset.westmoreBundleOffer !== 'true') return false;
    if (productForm._skipWestmoreOffer) return false;
    if (productForm.submitButton && productForm.submitButton.getAttribute('aria-disabled') === 'true') return false;
    const offer = document.querySelector('westmore-bundle-offer');
    if (!offer || typeof offer.open !== 'function') return false;
    offer.open(productForm);
    return true;
  }

  document.addEventListener(
    'submit',
    function (event) {
      const productForm = event.target.closest && event.target.closest('product-form');
      if (!openWestmoreOffer(productForm)) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const submit = event.target.closest && event.target.closest(
        'product-form[data-westmore-bundle-offer="true"] [type="submit"], product-form[data-westmore-bundle-offer="true"] [name="add"]'
      );
      if (!submit) return;
      const productForm = submit.closest('product-form');
      if (!openWestmoreOffer(productForm)) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  function bindWestmoreShadePicker(picker) {
    if (!picker || picker.dataset.bound === 'true') return;
    picker.dataset.bound = 'true';
    const hiddenInput = picker.querySelector('[data-wbc-variant]');
    const labelEl = picker.querySelector('[data-wbc-shade-label]');
    const radios = picker.querySelectorAll('[data-wbc-shade-radio]');

    const syncSelection = (radio) => {
      if (!radio || !hiddenInput) return;
      hiddenInput.value = radio.value;
      if (labelEl) labelEl.textContent = radio.dataset.shadeValue || radio.value;
      radios.forEach((input) => {
        const swatch = input.nextElementSibling;
        if (!swatch) return;
        swatch.classList.toggle('is-active', input === radio);
      });
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) syncSelection(radio);
      });
    });

    const checked = picker.querySelector('[data-wbc-shade-radio]:checked') || radios[0];
    if (checked) syncSelection(checked);
  }

  function bindCartWidget(root) {
    const widget = (root || document).querySelector('[data-westmore-cart-bundle]');
    if (!widget || widget.dataset.bound === 'true') return;
    widget.dataset.bound = 'true';
    const currentQty = Number(widget.dataset.currentQty || 0);
    const sellingPlan = widget.dataset.sellingPlan;
    const addButton = widget.querySelector('[data-wbc-add]');
    const shadePicker = widget.querySelector('[data-wbc-shade-picker]');
    bindWestmoreShadePicker(shadePicker);
    const variantSelect = widget.querySelector('[data-wbc-variant]');
    widget.querySelectorAll('[data-wbc-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        widget.querySelectorAll('.wbc__option').forEach((option) => option.classList.remove('is-selected'));
        button.classList.add('is-selected');
      });
    });
    addButton.addEventListener('click', () => {
      const selected = widget.querySelector('.wbc__option.is-selected');
      const targetQty = Number(selected && selected.dataset.wbcQty);
      const addQty = targetQty - currentQty;
      const variantId = variantSelect && variantSelect.value;
      if (!addQty || addQty < 1 || !variantId) return;
      addButton.disabled = true;
      const item = { id: Number(variantId), quantity: addQty };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      const config = fetchConfigJSON();
      const drawer = document.querySelector('cart-drawer');
      const payload = { items: [item] };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map((section) => section.id).join(',');
        payload.sections_url = window.location.pathname;
      }
      config.body = JSON.stringify(payload);
      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(response);
          } else {
            refreshCart(response.sections);
          }
        })
        .finally(() => {
          addButton.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', () => bindCartWidget(document));
  document.addEventListener('shopify:section:load', (event) => bindCartWidget(event.target));
  const cartRoot = document.getElementById('CartDrawer') || document.body;
  const observer = new MutationObserver(() => bindCartWidget(cartRoot));
  if (cartRoot) observer.observe(cartRoot, { childList: true, subtree: true });
})();
